export default {
  en: {
    title: "",
  },
  pl: {
    title: "Partnerzy 2024",
    description:
      "Chcesz wesprzeć inicjatywę oferując swoją wiedzę i talent lub dostęp do danych? Napisz do nas! Przygotujemy dla Ciebie ofertę współpracy i razem zrobimy coś dobrego. Bądź częścią zmiany!",
    button: "Wypełnij formularz &rarr;",
    boxTitle: "Dołącz do nas",
    organizers: {
      title: "Organizatorzy 2026",
      logos: [
        {
          title: " ",
          elements: [
            {
              image:
                require("./images/PODSTAWOWA codeme_logo_black_red_subtitle_black_rgb.png").default,
              url: "http://codeme.pl/",
            },
            {
              image: require("./images/LOGO_KA_gold-01.jpg").default,
              url: "https://kaminskiacademy.com/",
            },
            {
              image: require("./images/biologia_ug.png").default,
              url: "https://biology.ug.edu.pl/",
            },
          ]
        },
      ],
    },
    partners: {
      title: "Partnerzy 2026",
      logos: [
        {
          title: "Partnerzy główni:",
          elements: [
            {
              image:
                require("./images/balticon.svg").default,
              url: "https://balticon.pl/",
            },
            {
              image:
                require("./images/invest_gda.svg").default,
              url: "https://www.fundacja.investgda.pl/",
            },
            {
              image:
                require("./images/edih_fill.jpg").default,
              url: "https://www.gov.pl/web/cyber-nccpl/europejskie-huby-innowacji-cyfrowych-european-digital-innovation-hub-edih",
            },
            {
              image:
                require("./images/ecofuture_czarne.png").default,
              url: "https://www.fundacja.investgda.pl/",
            },
          ],
        },
        {
          title: "Partronat honorowy:",
          elements: [
            {
              image:
                require("./images/ministerstwo_cyfryzacji.png").default,
              url: "https://www.gov.pl/web/cyfryzacja",
            },
          ],
        },
        {
          title: "Partnerzy strategiczni:",
          elements: [
            {
              image:
                require("./images/compiled.svg").default,
              url: "https://compiled.pl/",
            },
            {
              image:
                require("./images/rust.png").default,
              url: "https://poland.rs/",
            },
          ],
        },
        {
          title: "Partnerzy merytoryczni:",
          elements: [
            {
              image: require("./images/sygnet-wasyluk.svg").default,
              url: "https://wasylukprojektowaniekreatywne.pl/",
            },
            {
              image: require("./images/vita.webp").default,
              url: "https://historiavita.pl/",
            },
            {
              image: require("./images/Wraki.webp").default,
              url: "https://savebaltic.com/",
            },
            {
              image: require("./images/simplitio.svg").default,
              url: "https://www.simplito.com/",
            },
            {
              image: require("./images/obszar.jpg").default,
              url: "https://www.metropoliagdansk.pl/",
            },
            {
              image: require("./images/a11y.png").default,
              url: "https://a11y.org.pl/",
            },
            {
              image: require("./images/Glyph.svg").default,
              url: "https://reline.ai/",
            },
            {
              image: require("./images/resqvest.png").default,
              url: "https://resqvest.com/",
            },
            {
              image: require("./images/logo-1.webp").default,
              url: "https://www.icutech.pl/",
            },
            {
              image: require("./images/nautil_logo.png").default,
              url: "https://nautil.pl/",
            },
            {
              image: require("./images/catboat.jpg").default,
              url: "https://www.oferteo.pl/catboat-strings-bartosz-skelnik/firma/5765927",
            },
            {
              image: require("./images/pjatk.svg").default,
              url: "https://gdansk.pja.edu.pl/",
            },
            {
              image: require("./images/SWPS_University.svg.png").default,
              url: "https://www.swps.pl/",
            },
            {
              image: require("./images/hevelianum_logo.png").default,
              url: "https://hevelianum.pl/",

            },
            {
              image: require("./images/jit.webp").default,
              url: "https://jit.team/",
            },
            {
              image: require("./images/outline.png").default,
              url: "https://www.outlineai.com/",
            },
            {
              image: require("./images/1.jpg").default,
              url: "https://strefa.gda.pl/",
            },
            {
              image: require("./images/2.jpg").default,
              url: "https://strefa.gda.pl/",
            },
            {
              image: require("./images/3.jpg").default,
              url: "https://strefa.gda.pl/",
            },
          ],
        },
        {
          title: "Partnerzy medialni i społecznościowi:",
          elements: [
            {
              image:
                require("./images/radio-mors.df2cd724.webp").default,
              url: "https://mors.ug.edu.pl/",
            },
            {
              image:
                require("./images/kosmonauta.webp").default,
              url: "https://kosmonauta.net/",
            },
            {
              image: require("./images/hackerspace.png").default,
              url: "https://hs3.pl/",
            },
            {
              image: require("./images/cdn.png").default,
              url: "https://cdn.ug.edu.pl/",
            },
            {
              image: require("./images/logo-ngo.png").default,
              url: "https://www.ngo.pl/",
            },
            {
              image: require("./images/DB.jpg").default,
              url: "https://dziennikbaltycki.pl/",
            },
          ],
        },
        {
          title: "Partnerzy wspierający:",
          elements: [

            {
              image: require("./images/logo Beka.jpg").default,
              url: "https://www.facebook.com/p/Rezerwat-Przyrody-Beka-100067406709172/",
            },
            {
              image: require("./images/bat.jpg").default,
              url: "https://bat.pl/",
            },
            {
              image: require("./images/kosakowo_logo_CMYK (1).png").default,
              url: "https://gminakosakowo.pl/",
            },
            {
              image: require("./images/logo_WODY-POLSKIE_pl-poziom.jpg").default,
              url: "https://www.gov.pl/web/wody-polskie/",
            },
            {
              image: require("./images/kajaki_3.jpg").default,
              url: "https://www.facebook.com/kajaki3miasto/",
            },
            {
              image: require("./images/kajaki.png").default,
              url: "https://naszekajaki.pl/",
            },
            {
              image: require("./images/czarne_wiosła.svg").default,
              url: "https://www.czarnewiosla.pl/",
            },
            {
              image: require("./images/logo-edufun.png").default,
              url: "https://edufun.pl/",
            },
            {
              image: require("./images/otop.png").default,
              url: "https://otop.org.pl/",
            },
            {
              image: require("./images/peko2.jpg").default,
              url: "https://pukpeko.pl/",
            },
            {
              image: require("./images/REDA-LOGO.jpg").default,
              url: "https://miasto.reda.pl/",
            },
          ],
        },
      ],
    },
    partnersOthers: {
      logos: [
        // {
        //   title: " ",
        //   elements: [
        //     {
        //       image: require("./images/POMORSKIE-kolor-RGB.png").default,
        //       url: "https://pomorskie.eu/",
        //     },
        //     {
        //       image: require("./images/ISP_kolor.jpg").default,
        //       url: "https://pomorskie.eu/smart-progress/",
        //     }
        //   ],
        // },
      ],
    },
  },
}
